import { render, staticRenderFns } from "./ServiceMA.vue?vue&type=template&id=69d2d26a"
import script from "./ServiceMA.vue?vue&type=script&lang=js"
export * from "./ServiceMA.vue?vue&type=script&lang=js"
import style0 from "./ServiceMA.vue?vue&type=style&index=0&id=69d2d26a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports